import React, { useEffect, useState } from "react";
import "./App.css";

export default function PortfolioWebsite() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    document.body.style.overflow = isMobileMenuOpen ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [isMobileMenuOpen]);

  return (
    <div id="work" className="min-h-screen bg-white t-black">

      {/* Header */}
      <header className="px-5 sm:px-6 h-[128px] flex items-center">
        <div className="mx-auto flex h-full w-full max-w-[var(--page-max)] items-center justify-between">
          <div className="t-logo">Neves Purificacao Rodrigues</div>

          {/* Desktop nav */}
          <div className="hidden items-center gap-2 sm:flex">
            <span className="nav-pill nav-pill--active"><span className="t-btn">Work</span></span>
            <a href="#about" className="nav-pill nav-pill--inactive"><span className="t-btn">About</span></a>
          </div>

          {/* Mobile menu */}
          <button
            className="inline-flex items-center justify-center rounded-full p-2 t-black hover:bg-neutral-100 sm:hidden"
            aria-label={isMobileMenuOpen ? "Close menu" : "Open menu"}
            aria-expanded={isMobileMenuOpen}
            type="button"
            onClick={() => setIsMobileMenuOpen((prev) => !prev)}
          >
            <HamburgerIcon />
          </button>
        </div>
      </header>

      {isMobileMenuOpen ? (
        <div className="fixed inset-0 z-50 bg-white sm:hidden">
          <div className="flex h-full flex-col">
            <header className="px-5 sm:px-6 h-[128px] flex items-center">
              <div className="mx-auto flex h-full w-full max-w-[var(--page-max)] items-center justify-between">
                <div className="t-logo">Neves Purificacao Rodrigues</div>
                <button
                  type="button"
                  aria-label="Close menu"
                  className="inline-flex items-center justify-center rounded-full p-2 t-black hover:bg-neutral-100"
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  <CloseIcon />
                </button>
              </div>
            </header>

            <nav className="mt-4 px-5">
              <a
                href="#work"
                className="t-mobile-menu-link block border-b border-[#dcdcdc] py-5"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                Work
              </a>
              <a
                href="#about"
                className="t-mobile-menu-link block border-b border-[#dcdcdc] py-5"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                About
              </a>
            </nav>

            <div className="mt-auto border-t border-[#dcdcdc] px-5 pt-6 pb-8">
              <div className="flex items-center gap-4">
                <a
                  href="mailto:neves0202@gmail.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Email"
                  className="inline-flex h-[44px] w-[44px] items-center justify-center rounded-full bg-neutral-100 hover:bg-neutral-200"
                >
                  <MailIcon />
                </a>
                <a
                  href="https://www.linkedin.com/in/nevesrodrigues/"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="LinkedIn"
                  className="inline-flex h-[44px] w-[44px] items-center justify-center rounded-full bg-neutral-100 hover:bg-neutral-200"
                >
                  <LinkedInIcon />
                </a>
                <a
                  href="https://twoplustwofive.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Photography"
                  className="inline-flex h-[44px] w-[44px] items-center justify-center rounded-full bg-neutral-100 hover:bg-neutral-200"
                >
                  <CameraIcon />
                </a>
              </div>
            </div>
          </div>
        </div>
      ) : null}

      {/* Hero */}
      <section className="px-5 pb-8 pt-[40px] sm:px-6 sm:pb-10 sm:pt-[40px]">
        <div className="mx-auto max-w-[var(--page-max)]">
          <h1 className="t-h1">Design leader building{" "}<br className="hidden sm:block" />{" "}trusted AI systems</h1>

          {/* Announcement blurb */}
          <div className="mt-[12px] w-full">
            <HeroAnnouncement />
          </div>

          {/* Featured images */}
          <FeaturedCardsCarousel />
        </div>
      </section>

      {/* Section: Copilot for health */}
      <Section>
        <CaseHeader
          title="Copilot for health"
          org="Microsoft Healthcare AI"
          date="2025"
          href="https://www.microsoft.com/en-us/microsoft-copilot/blog/2025/10/23/human-centered-ai/#:~:text=to%20add%C2%A0value.-,Copilot%20for%20health,-5%C2%A0addresses"
          blurb="Partnered with the founding team to design the vision for Copilot for Health at Microsoft. Supported the healthcare journey from health plan comparison to finding the right physician. Focused on the citations experience and medically grounded answer cards inside Copilot chat, integrating trusted sources such as Harvard Health to ensure credibility, transparency and responsible AI in high-stakes clinical contexts."
        />

        <div className="mt-[80px] p-0 xl:px-[50px]">
          <VideoEmbed className="w-full rounded-[12px]" videoId="NFNTNoW2mdc" />
        </div>

        <FourUpFlow />
      </Section>

      {/* Section: Medical Superintelligence */}
      <Section>
        <SectionHeader
          title="Medical Superintelligence"
          org="Microsoft Healthcare AI"
          date="June 2025"
          href="https://microsoft.ai/news/the-path-to-medical-superintelligence/"
          blurb="Primary designer on Microsoft’s Medical Superintelligence work, designing the agent-based experiences that coordinate complex medical reasoning across tasks. Focused on how AI agents collaborate, present evidence, and support clinicians in solving some of the most compelling cases in medical history, while managing diagnostic cost and accuracy."
          showArrow
        />

        <div className="mt-[80px] flex flex-col items-center gap-[20px] p-0 md:px-[50px] md:flex-row">
          <div className="aspect-square flex-1 min-w-0 rounded-[12px] bg-[#EAEAEA] p-[1px]">
            <img
              src="/assets/images/Microsoft%201.png"
              alt="Medical Superintelligence screenshot 1"
              className="h-full w-full rounded-[11px] bg-white object-contain"
            />
          </div>
          <div className="aspect-square flex-1 min-w-0 rounded-[12px] bg-[#EAEAEA] p-[1px]">
            <img
              src="/assets/images/Microsoft%202.png"
              alt="Medical Superintelligence screenshot 2"
              className="h-full w-full rounded-[11px] bg-white object-contain"
            />
          </div>
        </div>
      </Section>

      {/* Section: Agentic AI Platform */}
      <Section>
        <CaseHeader
          title="Agentic AI Platform"
          org="Surface AI"
          date="2025–2026"
          href="https://getsurface.ai"
          blurb="VP of Design at SurfaceAI. Building AI agents that help multifamily operators uncover revenue, automate workflows, and run smarter operations. Focusing on building transparent, controllable agent-based systems that surface evidence, explain decisions, and integrate cleanly into complex operational workflows."
        />

        <div className="mt-[80px] flex flex-col items-center gap-[20px] p-0 md:px-[50px] md:flex-row">
          <img
            src="/assets/images/Surface%201.png"
            alt="Surface AI platform screenshot 1"
            className="w-full aspect-square md:flex-1 min-w-0 rounded-[12px] bg-white object-contain border border-[#EAEAEA]"
          />
          <img
            src="/assets/images/Surface%202.png"
            alt="Surface AI platform screenshot 2"
            className="w-full aspect-square md:flex-1 min-w-0 rounded-[12px] bg-white object-contain border border-[#EAEAEA]"
          />
        </div>
      </Section>

      {/* Section: Commons Platform */}
      <Section>
        <SectionHeader
          title="Commons Platform"
          org="Cityblock Health"
          date="2018–2025"
          href="https://medium.com/cityblock-health/when-coders-care-teams-collaborate-426e1426b14b"
          blurb="Led design at Cityblock Health on the Commons Platform, a care-team workspace for Medicaid populations. Focused on fast triage, end-to-end healthcare journey, and measurable quality outcomes. Supported clinicians and care teams in delivering coordinated, high-quality care at scale."
          showArrow
        />

        <div className="mt-[80px] p-0 xl:px-[50px]">
          <img
            src="/assets/images/Cityblock%20Health%201.png"
            alt="Cityblock Health Commons platform"
            className="w-full rounded-[12px] object-cover"
          />
        </div>

        <CommonsFourUp />
      </Section>

      {/* Section: Compass Platform */}
      <Section>
        <SectionHeader
          title="Compass Platform"
          org="Compass Inc"
          date="2014–2018"
          href="https://www.compass.com/"
          blurb="First designer at Compass. Built Search from scratch and scaled it to support millions of homes nationwide. Led design across consumer listings, agent workflows and internal tooling while helping grow the design organization. Scaled the platform as the company grew into the No.1 brokerage in the world."
          showArrow
        />

        <div className="mt-[80px] flex flex-col items-center gap-[20px] p-0 xl:p-[50px] xl:flex-row">
          <img
            src="/assets/images/Compass%201.png"
            alt="Compass platform screenshot 1"
            className="w-full aspect-square md:flex-1 min-w-0 rounded-[12px] bg-white object-contain border border-[#EAEAEA]"
          />
          <img
            src="/assets/images/Compass%202.png"
            alt="Compass platform screenshot 2"
            className="w-full aspect-square md:flex-1 min-w-0 rounded-[12px] bg-white object-contain border border-[#EAEAEA]"
          />
        </div>
      </Section>

      {/* Divider before footer */}
      <div className="px-5 sm:px-6">
        <div className="mx-auto max-w-[var(--page-max)] border-t border-[#0000000d]" />
      </div>

      {/* Footer */}
      <footer id="about" className="px-5 pt-[120px] pb-[20px] sm:px-6">
        <div className="mx-auto max-w-[var(--page-max)]">
          <div className="grid grid-cols-1 gap-[40px] md:grid-cols-[360px_1fr] md:gap-[40px] md:ml-[130px]">
            {/* Avatar */}
            <div className="flex justify-center md:justify-start md:pl-[70px]">
              <img
                src="/assets/images/Neves.png"
                alt="Neves Rodrigues"
                className="h-[260px] w-[260px] rounded-full object-cover"
              />
            </div>

            {/* Bio */}
            <div className="flex flex-col">
              <h2 className="t-footer-hello mb-[16px]">Hello! 🤚</h2>

              {/* Line break after Hello */}
              <div className="h-[16px]" />

              <p className="t-project-body mb-[24px]">
                I’m Neves, designer and engineer based in New York City.
              </p>

              {/* Line break before experience */}
              <div className="h-[16px]" />

              <div className="space-y-[8px]">
              <p className="t-project-body" style={{ lineHeight: '30px' }}>
                18+ years working across healthcare, AI, and large-scale platforms.{" "}<br className="hidden sm:block" />
                Focused on building trustworthy systems for high-stakes decisions.{" "}<br className="hidden sm:block" />
                Founding designer at multiple companies, two that grew to $6B in valuation.{" "}<br className="hidden sm:block" />
                Led design work at Microsoft Healthcare AI, Cityblock Health, Compass.{" "}<br className="hidden sm:block" />
                Currently VP of Design at Surface AI.{" "}<br className="hidden sm:block" />
                Hiker, photographer, chef in training, avid reader.
              </p>
              </div>

              {/* Tags */}
              <div className="mt-[40px] flex flex-wrap gap-[12px]">
                {["AI UX", "Healthcare", "Platforms", "Design Systems", "Accessibility"].map((tag) => (
                  <span key={tag} className="footer-pill">
                    <span className="t-btn">{tag}</span>
                  </span>
                ))}
              </div>
            </div>
          </div>

          {/* Bottom bar */}
          <div className="mt-[240px] flex items-center justify-between">
            <div className="t-footer-text">© 2026 Neves Purificacao Rodrigues</div>
            <div className="flex items-center gap-[16px]">
              <a href="mailto:neves0202@gmail.com" target="_blank" rel="noopener noreferrer" aria-label="Email" className="inline-flex h-[40px] w-[40px] items-center justify-center rounded-full bg-neutral-100 hover:bg-neutral-200">
                <MailIcon />
              </a>
              
              <a href="https://www.linkedin.com/in/nevesrodrigues/" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn" className="inline-flex h-[40px] w-[40px] items-center justify-center rounded-full bg-neutral-100 hover:bg-neutral-200">
                <LinkedInIcon />
              </a>
              <a href="https://twoplustwofive.com" target="_blank" rel="noopener noreferrer" aria-label="Photography" className="inline-flex h-[40px] w-[40px] items-center justify-center rounded-full bg-neutral-100 hover:bg-neutral-200">
                <CameraIcon />
              </a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}

function Section({ children }) {
  return (
    <section className="px-5 py-[60px] sm:px-6">
      <div className="mx-auto max-w-[var(--page-max)] border-t border-[#0000000d] pt-[80px]">
        {children}
      </div>
    </section>
  );
}

// Section header for non-clickable sections (matches CaseHeader styling)
function SectionHeader({ title, org, date, blurb, showArrow = false, href }) {
  return (
    <div className="grid grid-cols-1 gap-[20px] sm:grid-cols-2 sm:items-start">
      <div>
        <div className="flex items-center gap-3">
          {href ? (
            <a
              href={href}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-3"
              aria-label={`${title} (opens in a new tab)`}
            >
              <span className="t-project-title">{title}</span>
              {showArrow ? (
                <span className="inline-flex items-center t-black" aria-hidden="true">
                  <ExternalIcon />
                </span>
              ) : null}
            </a>
          ) : (
            <>
              <span className="t-project-title">{title}</span>
              {showArrow ? (
                <span className="inline-flex items-center t-black" aria-hidden="true">
                  <ExternalIcon />
                </span>
              ) : null}
            </>
          )}
        </div>
        <div className="t-caption mt-[2px]">
          {org} · {date}
        </div>
      </div>

      <p className="t-project-body text-pretty">{blurb}</p>
    </div>
  );
}

function CaseHeader({ title, org, date, blurb, href }) {
  return (
    <div className="grid grid-cols-1 gap-[20px] sm:grid-cols-2 sm:items-start">
      <div>
        <div className="flex items-center gap-3">
          {href ? (
            <a
              href={href}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-3"
              aria-label={`${title} (opens in a new tab)`}
            >
              <span className="t-project-title">{title}</span>
              <span className="inline-flex items-center t-black" aria-hidden="true">
                <ExternalIcon />
              </span>
            </a>
          ) : (
            <>
              <span className="t-project-title">{title}</span>
              <span className="inline-flex items-center t-black" aria-hidden="true">
                <ExternalIcon />
              </span>
            </>
          )}
        </div>
        <div className="t-caption mt-[2px]">
          {org} · {date}
        </div>
      </div>

      <p className="t-project-body text-pretty">{blurb}</p>
    </div>
  );
}

// --- YouTube embed ---
let ytApiPromise = null;
function loadYouTubeIframeAPI() {
  if (typeof window === "undefined") return Promise.resolve();
  if (window.YT && window.YT.Player) return Promise.resolve();
  if (ytApiPromise) return ytApiPromise;

  ytApiPromise = new Promise((resolve) => {
    const existing = document.querySelector('script[src="https://www.youtube.com/iframe_api"]');
    if (!existing) {
      const tag = document.createElement("script");
      tag.src = "https://www.youtube.com/iframe_api";
      document.head.appendChild(tag);
    }

    const prev = window.onYouTubeIframeAPIReady;
    window.onYouTubeIframeAPIReady = () => {
      try {
        if (typeof prev === "function") prev();
      } finally {
        resolve();
      }
    };

    const start = Date.now();
    const t = setInterval(() => {
      if (window.YT && window.YT.Player) {
        clearInterval(t);
        resolve();
      }
      if (Date.now() - start > 8000) {
        clearInterval(t);
        resolve();
      }
    }, 200);
  });

  return ytApiPromise;
}

function PlayIcon() {
  return (
    <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <path d="M9 7.5v9l8-4.5-8-4.5Z" fill="currentColor" />
    </svg>
  );
}

function VideoEmbed({ videoId, className = "" }) {
  const [hasStarted, setHasStarted] = useState(false);
  const [hasEnded, setHasEnded] = useState(false);
  const playerRef = React.useRef(null);
  const playCountRef = React.useRef(0);
  const containerIdRef = React.useRef(`yt-player-${Math.random().toString(36).slice(2)}`);

  useEffect(() => {
    if (!hasStarted || hasEnded) return;

    let cancelled = false;

    const init = async () => {
      await loadYouTubeIframeAPI();
      if (cancelled) return;

      if (playerRef.current && playerRef.current.destroy) {
        try { playerRef.current.destroy(); } catch {}
      }

      if (!window.YT || !window.YT.Player) return;

      playerRef.current = new window.YT.Player(containerIdRef.current, {
        videoId,
        playerVars: {
          autoplay: 1,
          mute: 0,
          controls: 0,
          rel: 0,
          modestbranding: 1,
          playsinline: 1,
          showinfo: 0,
          iv_load_policy: 3,
          disablekb: 1,
          fs: 0,
        },
        events: {
          onStateChange: (event) => {
            if (event.data === window.YT.PlayerState.ENDED) {
              playCountRef.current += 1;
              if (playCountRef.current < 2) {
                try { playerRef.current.playVideo(); } catch {}
              } else {
                setHasEnded(true);
              }
            }
          },
        },
      });
    };

    init();

    return () => {
      cancelled = true;
      if (playerRef.current && playerRef.current.destroy) {
        try { playerRef.current.destroy(); } catch {}
      }
    };
  }, [hasStarted, hasEnded, videoId]);

  const handlePlay = () => {
    if (hasEnded) {
      playCountRef.current = 0;
      setHasEnded(false);
      setHasStarted(false);
      setTimeout(() => setHasStarted(true), 0);
      return;
    }
    setHasStarted(true);
  };

  return (
    <div
      className={`relative w-full overflow-hidden ${className}`}
      style={{ borderRadius: "12px", aspectRatio: "16 / 9" }}
      data-name="Video Embed"
    >
      {!hasStarted || hasEnded ? (
        <>
          <img
            src="/assets/images/Copilot-for-health.webp"
            alt="Copilot for Health video placeholder"
            className="absolute inset-0 h-full w-full object-cover"
          />
          <button
            onClick={handlePlay}
            className="absolute inset-0 flex items-center justify-center bg-black/10 hover:bg-black/20 transition-colors cursor-pointer"
            aria-label="Play video"
            type="button"
          >
            <div className="flex h-20 w-20 items-center justify-center rounded-full bg-[#FF0000] shadow-lg">
              <span className="text-white"><PlayIcon /></span>
            </div>
          </button>
        </>
      ) : (
        <>
          <div id={containerIdRef.current} className="absolute inset-0 h-full w-full" />
          <div className="absolute inset-0 pointer-events-none" style={{ zIndex: 10 }} />
        </>
      )}
    </div>
  );
}

function CommonsFourUp() {
  const urls = [
    "/assets/images/iPhone%2014%20Pro%20Deep%20Purple.png",
    "/assets/images/iPhone%2014%20Pro%20Deep%20Purple-2.png",
    "/assets/images/iPhone%2014%20Pro%20Deep%20Purple-1.png",
    "/assets/images/iPhone%2014%20Pro%20Deep%20Purple-3.png",
  ];

  const renderUrls = [urls[urls.length - 1], ...urls, urls[0]];
  const scrollerRef = React.useRef(null);
  const [active, setActive] = useState(0);
  const GAP = 20;

  useEffect(() => {
    const el = scrollerRef.current;
    if (!el) return;

    requestAnimationFrame(() => {
      const first = el.firstElementChild;
      if (!first) return;
      const step = first.getBoundingClientRect().width + GAP;
      el.scrollLeft = step;
    });

    let raf = 0;
    const onScroll = () => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => {
        const first = el.firstElementChild;
        if (!first) return;
        const step = first.getBoundingClientRect().width + GAP;
        const raw = Math.round(el.scrollLeft / Math.max(step, 1));

        if (raw === 0) {
          el.scrollLeft = step * urls.length;
          setActive(urls.length - 1);
          return;
        }
        if (raw === urls.length + 1) {
          el.scrollLeft = step;
          setActive(0);
          return;
        }

        const realIndex = raw - 1;
        setActive(Math.max(0, Math.min(urls.length - 1, realIndex)));
      });
    };

    el.addEventListener("scroll", onScroll, { passive: true });
    return () => {
      cancelAnimationFrame(raf);
      el.removeEventListener("scroll", onScroll);
    };
  }, [urls.length]);

  return (
    <div className="sp-s1">
      <div className="commons-fourup-mobile">
        <div ref={scrollerRef} className="flow-carousel gap-[20px] overflow-x-auto snap-x snap-mandatory pb-4 px-1">
          {renderUrls.map((src, idx) => {
            const imgNum = idx === 0 ? 4 : idx === renderUrls.length - 1 ? 1 : idx;
            return (
              <img
                key={`${idx}-${src}`}
                src={src}
                alt={`Commons iPhone ${imgNum}`}
                className="snap-start aspect-[9/19] w-[210px] sm:w-[calc((100%-20px)/2)] shrink-0 rounded-[12px] bg-transparent object-contain"
              />
            );
          })}
        </div>

        <div className="flow-dots" aria-hidden="true">
          {urls.map((_, i) => (
            <span key={i} className={`flow-dot ${i === active ? "active" : ""}`} />
          ))}
        </div>
      </div>

      <div className="px-[50px] py-0">
        <div className="flow-desktop w-full gap-[20px]">
          {urls.map((src, i) => (
            <img
              key={i}
              src={src}
              alt={`Commons iPhone ${i + 1}`}
              className="aspect-[9/19] w-0 flex-1 min-w-0 rounded-[12px] bg-transparent object-contain"
            />
          ))}
        </div>
      </div>
    </div>
  );
}

function FeaturedCardsCarousel() {
  const items = [
    {
      src: "/assets/images/Microsoft%20AI.png",
      alt: "Microsoft Healthcare AI",
    },
    {
      src: "/assets/images/Cityblock.png",
      alt: "Cityblock Health",
    },
    {
      src: "/assets/images/Compass.png",
      alt: "Compass",
    },
    {
      src: "/assets/images/SurfaceAI.png",
      alt: "SurfaceAI",
    },
  ];

  // Mobile/tablet: swipe scroll
  const scrollerRef = React.useRef(null);
  const [active, setActive] = useState(0);
  const GAP = 20;

  useEffect(() => {
    const el = scrollerRef.current;
    if (!el) return;

    let raf = 0;
    const onScroll = () => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => {
        const first = el.firstElementChild;
        if (!first) return;
        const step = first.getBoundingClientRect().width + GAP;
        const raw = Math.round(el.scrollLeft / Math.max(step, 1));
        setActive(Math.max(0, Math.min(items.length - 1, raw)));
      });
    };

    el.addEventListener("scroll", onScroll, { passive: true });
    return () => {
      cancelAnimationFrame(raf);
      el.removeEventListener("scroll", onScroll);
    };
  }, [items.length]);

  // Desktop: transform + wheel hijack (only when in view)
  const wrapRef = React.useRef(null);
  const trackRef = React.useRef(null);
  const [x, setX] = useState(0);
  const xRef = React.useRef(0);

  useEffect(() => {
    xRef.current = x;
  }, [x]);

  useEffect(() => {
    const wrap = wrapRef.current;
    const track = trackRef.current;
    if (!wrap || !track) return;

    let raf = 0;
    const clamp = (v, min, max) => Math.max(min, Math.min(max, v));

    const getBounds = () => {
      const wrapW = wrap.getBoundingClientRect().width;
      const trackW = track.scrollWidth;
      const maxLeft = Math.min(0, wrapW - trackW);
      return { maxLeft };
    };

    const apply = (next) => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => {
        xRef.current = next;
        setX(next);
      });
    };

    const onResize = () => {
      const { maxLeft } = getBounds();
      apply(clamp(xRef.current, maxLeft, 0));
    };

    const onWheel = (e) => {
      const isDesktop = window.matchMedia && window.matchMedia("(min-width: 1280px)").matches;
      if (!isDesktop) return;

      // Let trackpads / shift-horizontal pass through
      const isIntentionalHorizontal = e.shiftKey || Math.abs(e.deltaX) > Math.abs(e.deltaY);
      if (isIntentionalHorizontal) return;

      const rect = wrap.getBoundingClientRect();
      const vh = window.innerHeight || 0;
      const inView = rect.bottom > 0 && rect.top < vh;
      if (!inView) return;

      const { maxLeft } = getBounds();
      if (maxLeft === 0) return;

      const current = xRef.current;
      const next = clamp(current - e.deltaY, maxLeft, 0);

      // Only hijack vertical scroll if we actually moved horizontally
      if (next === current) return;

      e.preventDefault();
      apply(next);
    };

    onResize();
    window.addEventListener("resize", onResize);
    window.addEventListener("wheel", onWheel, { passive: false });

    return () => {
      cancelAnimationFrame(raf);
      window.removeEventListener("resize", onResize);
      window.removeEventListener("wheel", onWheel);
    };
  }, [items.length]);

  return (
    <div className="sp-s2">
      {/* Mobile + tablet: swipe */}
      <div className="featured-mobile">
        <div ref={scrollerRef} className="featured-cards-carousel px-1">
          {items.map((it, i) => (
            <div key={i} className="featured-card-item">
              <img src={it.src} alt={it.alt} className="w-full rounded-[20px] object-cover" />
            </div>
          ))}
        </div>
      </div>

      {/* Dots only for mobile/tablet */}
      <div className="featured-mobile">
        <div className="flow-dots" aria-hidden="true">
          {items.map((_, i) => (
            <span key={i} className={`flow-dot ${i === active ? "active" : ""}`} />
          ))}
        </div>
      </div>

      {/* Desktop: transform strip */}
      <div className="featured-desktop">
        <div ref={wrapRef} className="featured-transform-wrap">
          <div
            ref={trackRef}
            className="featured-transform-track"
            style={{ transform: `translate3d(${x}px, 0px, 0px)` }}
          >
            {items.map((it, i) => (
              <div key={i} className="featured-transform-item">
                <img src={it.src} alt={it.alt} className="w-full rounded-[20px] object-cover" />
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

function FourUpFlow() {
  const GAP = 20;

  const ids = [
    "7ed76e59-6b19-43e9-818e-91e2db451223",
    "ad44ab01-2641-44c4-a76d-2e65c4b15d6e",
    "75557e8c-a0b2-4816-a92b-4b3c71edc839",
    "3ac79199-8f5f-4c8b-b675-dbebe7a2d405",
  ];

  const renderIds = [ids[ids.length - 1], ...ids, ids[0]];
  const scrollerRef = React.useRef(null);
  const [active, setActive] = useState(0);

  useEffect(() => {
    const el = scrollerRef.current;
    if (!el) return;

    requestAnimationFrame(() => {
      const first = el.firstElementChild;
      if (!first) return;
      const step = first.getBoundingClientRect().width + GAP;
      el.scrollLeft = step;
    });

    let raf = 0;
    const onScroll = () => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => {
        const first = el.firstElementChild;
        if (!first) return;
        const step = first.getBoundingClientRect().width + GAP;
        const raw = Math.round(el.scrollLeft / Math.max(step, 1));

        if (raw === 0) {
          el.scrollLeft = step * ids.length;
          setActive(ids.length - 1);
          return;
        }
        if (raw === ids.length + 1) {
          el.scrollLeft = step;
          setActive(0);
          return;
        }

        const realIndex = raw - 1;
        setActive(Math.max(0, Math.min(ids.length - 1, realIndex)));
      });
    };

    el.addEventListener("scroll", onScroll, { passive: true });
    return () => {
      cancelAnimationFrame(raf);
      el.removeEventListener("scroll", onScroll);
    };
  }, [ids.length]);

  return (
    <div className="sp-s1">
      <div className="p-0 lg:px-[50px]">
        <div ref={scrollerRef} className="flow-carousel gap-[20px] overflow-x-auto snap-x snap-mandatory pb-4 px-1">
          {renderIds.map((id, idx) => {
            const imgNum = idx === 0 ? 4 : idx === renderIds.length - 1 ? 1 : idx;
            return (
              <img
                key={`${id}-${idx}`}
                src={`/assets/images/M${imgNum}.png`}
                alt={`Copilot flow ${imgNum}`}
                className="snap-start aspect-[9/19] w-[210px] sm:w-[calc((100%-20px)/2)] shrink-0 rounded-[12px] bg-transparent object-contain"
              />
            );
          })}
        </div>

        <div className="flow-dots" aria-hidden="true">
          {ids.map((_, i) => (
            <span key={i} className={`flow-dot ${i === active ? "active" : ""}`} />
          ))}
        </div>

        <div className="flow-desktop w-full gap-[20px]">
          {ids.map((id, i) => (
            <img
              key={i}
              src={`/assets/images/M${i + 1}.png`}
              alt={`Copilot flow ${i + 1}`}
              className="phone aspect-[9/19] w-0 flex-1 min-w-0 rounded-[12px] bg-transparent object-contain overflow-visible"
            />
          ))}
        </div>
      </div>
    </div>
  );
}

function HeroAnnouncement() {
  const items = [
    {
      text: "Microsoft Says Its New AI System Diagnosed Patients 4 Times More Accurately Than Human Doctors - Wired",
      href: "https://www.wired.com/story/microsoft-medical-superintelligence-diagnosis/",
    },
    {
      text: "Compass Acquires Top Rival, Creating World’s Largest Brokerage - The New York Times",
      href: "https://www.nytimes.com/2026/01/09/realestate/compass-anywhere-real-estate-merger.html",
    },
    {
      text: "A spin-out from Google parent company Alphabet aims to help low-income Americans get better health care - CNBC",
      href: "https://www.cnbc.com/2017/10/02/cityblock-alphabet-spinout-wants-to-redesign-health-care.html",
    },
  ];

  const [index, setIndex] = useState(0);
  const [animKey, setAnimKey] = useState(0);
  const [wiggle, setWiggle] = useState(false);

  useEffect(() => {
    let intervalId;
    let wiggleResetId;
    let firstTickId;

    const advance = () => {
      // Toggle off/on so the bell animation reliably retriggers.
      setWiggle(false);
      requestAnimationFrame(() => setWiggle(true));
      if (wiggleResetId) clearTimeout(wiggleResetId);
      wiggleResetId = window.setTimeout(() => setWiggle(false), 850);

      setIndex((prev) => (prev + 1) % items.length);
      setAnimKey((v) => v + 1);
    };

    // Trigger sooner so animation is visible quickly on mobile.
    firstTickId = window.setTimeout(advance, 2000);
    intervalId = window.setInterval(advance, 8000);

    return () => {
      if (firstTickId) clearTimeout(firstTickId);
      if (intervalId) clearInterval(intervalId);
      if (wiggleResetId) clearTimeout(wiggleResetId);
    };
  }, [items.length]);

  return (
    <div className="announce-row">
      <span
        className={`announce-bell inline-flex h-6 w-6 items-center justify-center ${wiggle ? "announce-wiggle" : ""}`}
        aria-hidden="true"
      >
        <BellIcon />
      </span>
      <a
        key={animKey}
        href={items[index].href}
        target="_blank"
        rel="noopener noreferrer"
        className="announce-text announce-enter t-news"
        title={items[index].text}
      >
        {items[index].text}
      </a>
    </div>
  );
}

function HamburgerIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <path d="M4 7H20" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
      <path d="M4 12H20" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
      <path d="M4 17H20" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    </svg>
  );
}

function CloseIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <path d="M6 6L18 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
      <path d="M18 6L6 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    </svg>
  );
}

function BellIcon() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <mask id="mask0" style={{ maskType: "alpha" }} maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0)">
        <path
          d="M5.25 18.8845C5.0375 18.8845 4.85942 18.8127 4.71575 18.669C4.57192 18.5252 4.5 18.3469 4.5 18.1343C4.5 17.9218 4.57192 17.7437 4.71575 17.6C4.85942 17.4565 5.0375 17.3848 5.25 17.3848H6.30775V9.923C6.30775 8.57817 6.72283 7.38908 7.553 6.35575C8.383 5.32242 9.44867 4.6615 10.75 4.373V3.75C10.75 3.40283 10.8714 3.10767 11.1143 2.8645C11.3571 2.6215 11.6519 2.5 11.9988 2.5C12.3458 2.5 12.641 2.6215 12.8845 2.8645C13.1282 3.10767 13.25 3.40283 13.25 3.75V4.373C14.5513 4.6615 15.617 5.32242 16.447 6.35575C17.2772 7.38908 17.6923 8.57817 17.6923 9.923V17.3848H18.75C18.9625 17.3848 19.1406 17.4566 19.2843 17.6003C19.4281 17.7441 19.5 17.9223 19.5 18.135C19.5 18.3475 19.4281 18.5256 19.2843 18.6693C19.1406 18.8128 18.9625 18.8845 18.75 18.8845H5.25ZM11.9983 21.6923C11.5008 21.6923 11.0754 21.5153 10.7223 21.1613C10.3689 20.8073 10.1923 20.3817 10.1923 19.8845H13.8077C13.8077 20.3833 13.6306 20.8093 13.2762 21.1625C12.9219 21.5157 12.4959 21.6923 11.9983 21.6923ZM7.80775 17.3848H16.1923V9.923C16.1923 8.76533 15.783 7.77725 14.9645 6.95875C14.1458 6.14008 13.1577 5.73075 12 5.73075C10.8423 5.73075 9.85417 6.14008 9.0355 6.95875C8.217 7.77725 7.80775 8.76533 7.80775 9.923V17.3848Z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
}

function LinkedInIcon() {
  return (
    <svg width="14" height="13" viewBox="0 0 14 13" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <path fillRule="evenodd" clipRule="evenodd" d="M2.99283 12.6001V4.09846H0.167044V12.6001H2.99283ZM1.57992 2.93771C2.56533 2.93771 3.17867 2.28488 3.17867 1.46903C3.1603 0.634813 2.56534 9.72013e-05 1.59862 9.72013e-05C0.632002 9.72013e-05 0 0.634813 0 1.46903C0 2.28488 0.613204 2.93771 1.56151 2.93771H1.57992Z" fill="currentColor" />
      <path fillRule="evenodd" clipRule="evenodd" d="M4.55469 12.6001H7.38045V7.85243C7.38045 7.59834 7.39881 7.3445 7.47343 7.16287C7.6777 6.65519 8.14266 6.12941 8.92329 6.12941C9.94581 6.12941 10.3548 6.90903 10.3548 8.05192V12.6001H13.1804V7.72538C13.1804 5.11406 11.7863 3.89897 9.92714 3.89897C8.40271 3.89897 7.73348 4.75104 7.36165 5.33142H7.38052V4.09846H4.55476C4.59185 4.8962 4.55469 12.6001 4.55469 12.6001Z" fill="currentColor" />
    </svg>
  );
}

function MailIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <mask
        id="mask0_1999_25542"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="16"
        height="16"
      >
        <rect width="16" height="16" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_1999_25542)">
        <path
          d="M2.87314 13C2.53636 13 2.2513 12.8833 2.01797 12.65C1.78464 12.4167 1.66797 12.1316 1.66797 11.7948V4.20517C1.66797 3.86839 1.78464 3.58333 2.01797 3.35C2.2513 3.11667 2.53636 3 2.87314 3H13.1295C13.4662 3 13.7513 3.11667 13.9846 3.35C14.218 3.58333 14.3346 3.86839 14.3346 4.20517V11.7948C14.3346 12.1316 14.218 12.4167 13.9846 12.65C13.7513 12.8833 13.4662 13 13.1295 13H2.87314ZM13.3346 4.9615L8.32564 8.168C8.27441 8.197 8.22141 8.21983 8.16664 8.2365C8.11197 8.25317 8.05686 8.2615 8.0013 8.2615C7.94575 8.2615 7.89064 8.25317 7.83597 8.2365C7.78119 8.21983 7.72819 8.197 7.67697 8.168L2.66797 4.9615V11.7948C2.66797 11.8547 2.68719 11.9039 2.72564 11.9423C2.76408 11.9808 2.81325 12 2.87314 12H13.1295C13.1894 12 13.2385 11.9808 13.277 11.9423C13.3154 11.9039 13.3346 11.8547 13.3346 11.7948V4.9615ZM8.0013 7.33333L13.2321 4H2.77047L8.0013 7.33333ZM2.66797 5.11533V4.35317V4.373V4.35183V5.11533Z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
}



function CameraIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <mask
        id="mask0_1999_25552"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="16"
        height="16"
      >
        <rect width="16" height="16" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_1999_25552)">
        <path
          d="M8.0013 11.4103C8.7663 11.4103 9.4148 11.1443 9.9468 10.6123C10.4788 10.0803 10.7448 9.43183 10.7448 8.66683C10.7448 7.90183 10.4788 7.25333 9.9468 6.72133C9.4148 6.18933 8.7663 5.92333 8.0013 5.92333C7.2363 5.92333 6.5878 6.18933 6.0558 6.72133C5.5238 7.25333 5.2578 7.90183 5.2578 8.66683C5.2578 9.43183 5.5238 10.0803 6.0558 10.6123C6.5878 11.1443 7.2363 11.4103 8.0013 11.4103ZM8.0013 10.4105C7.50897 10.4105 7.0953 10.2429 6.7603 9.90783C6.42519 9.57283 6.25764 9.15916 6.25764 8.66683C6.25764 8.1745 6.42519 7.76083 6.7603 7.42583C7.0953 7.09072 7.50897 6.92316 8.0013 6.92316C8.49364 6.92316 8.9073 7.09072 9.2423 7.42583C9.57741 7.76083 9.74497 8.1745 9.74497 8.66683C9.74497 9.15916 9.57741 9.57283 9.2423 9.90783C8.9073 10.2429 8.49364 10.4105 8.0013 10.4105ZM2.87314 13.6668C2.53636 13.6668 2.2513 13.5502 2.01797 13.3168C1.78464 13.0835 1.66797 12.7984 1.66797 12.4617V4.872C1.66797 4.53522 1.78464 4.25016 2.01797 4.01683C2.2513 3.7835 2.53636 3.66683 2.87314 3.66683H4.90897L5.7808 2.722C5.89025 2.60144 6.02252 2.50655 6.17764 2.43733C6.33275 2.36811 6.49619 2.3335 6.66797 2.3335H9.33464C9.50641 2.3335 9.66986 2.36811 9.82497 2.43733C9.98008 2.50655 10.1124 2.60144 10.2218 2.722L11.0936 3.66683H13.1295C13.4662 3.66683 13.7513 3.7835 13.9846 4.01683C14.218 4.25016 14.3346 4.53522 14.3346 4.872V12.4617C14.3346 12.7984 14.218 13.0835 13.9846 13.3168C13.7513 13.5502 13.4662 13.6668 13.1295 13.6668H2.87314ZM2.87314 12.6668H13.1295C13.1894 12.6668 13.2385 12.6476 13.277 12.6092C13.3154 12.5707 13.3346 12.5216 13.3346 12.4617V4.872C13.3346 4.81211 13.3154 4.76294 13.277 4.7245C13.2385 4.68605 13.1894 4.66683 13.1295 4.66683H10.6475L9.4243 3.3335H6.5783L5.35514 4.66683H2.87314C2.81325 4.66683 2.76408 4.68605 2.72564 4.7245C2.68719 4.76294 2.66797 4.81211 2.66797 4.872V12.4617C2.66797 12.5216 2.68719 12.5707 2.72564 12.6092C2.76408 12.6476 2.81325 12.6668 2.87314 12.6668Z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
}

function ExternalIcon() {
  return (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <g clipPath="url(#clip0)">
        <path d="M0 11.6134L10.0876 1.29041" stroke="currentColor" strokeWidth="2.55116" strokeLinecap="round" />
        <path d="M1.25781 1.29041H10.0845V10.323" stroke="currentColor" strokeWidth="2.55116" strokeLinecap="round" />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect width="11.3486" height="11.6134" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
